/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { service } from "@ember/service";
import Component from "@glimmer/component";
import FollowUpReason from "core/models/follow-up-reason";
import { FollowUpReasonStringEnum } from "core/models/patient-enrolled-journal-event";
import { TreatmentProtocol } from "core/models/protocol";
import { EmberChangeset } from "ember-changeset";
import IntlService from "ember-intl/services/intl";
let TreatmentHistoryEditionFormProtocolsViewComponent = (_class = class TreatmentHistoryEditionFormProtocolsViewComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get specificProtocols() {
    switch (this.args.followUpReasonId) {
      case "onco-breast-cancer":
      case "onco-breast-cancer-tnm0":
        return ["abemaciclib-verzenios", "ribociclib-kisqali", "raac-gynecological-surgery"];
      case "onco-lung-cancer":
        return ["atezolizumab", "pembrozimulab", "carboplatine-alimta-pembrozimulab"];
      case "onco-pancreatic-cancer":
        return ["regorafenib-stivarga-initial", "regorafenib-stivarga-renewal", "olaparib-initial", "olaparib-following"];
      case "onco-prostate-cancer":
        return ["prostatectomy-total", "adt-anti-androgen", "adt-chemo"];
      case "onco-ovarian-cancer":
      case "onco-cervix-cancer":
        return ["raac-gynecological-surgery"];
      default:
        return [];
    }
  }
  get defaultProtocols() {
    return ["default-chemotherapy", "default-radiotherapy", "default-immunotherapy", "default-other-follow-up-events", "default-targeted-therapy", "default-surgery", "default-hormonotherapy"];
  }
  get translatedAndSortedProtocols() {
    const defaultProtocols = this.defaultProtocols;
    const translatedProtocols = defaultProtocols.map(protocol => ({
      original: protocol,
      translated: this.intl.t(`treatment-protocol.${protocol}`)
    }));
    translatedProtocols.sort((a, b) => a.translated.localeCompare(b.translated));
    return translatedProtocols;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TreatmentHistoryEditionFormProtocolsViewComponent as default };